import React, { Component } from 'react';

class CircleOChevronRight extends Component {
  render() {
    return (
      <svg className="CircleOChevronRight SiteIcon" width="17" height="17" viewBox="0 0 17 17">
        <polygon points="7.7,13.2 6.3,11.8 9.5,8.6 6.3,5.4 7.7,4 12.3,8.6" />
        <path d="M8.6,17.2C3.9,17.2,0,13.4,0,8.6S3.9,0,8.6,0s8.6,3.9,8.6,8.6S13.4,17.2,8.6,17.2z M8.6,1.8
          c-3.8,0-6.9,3.1-6.9,6.9s3.1,6.9,6.9,6.9s6.9-3.1,6.9-6.9S12.4,1.8,8.6,1.8z"/>
      </svg>
    );
  }
}

export default CircleOChevronRight;



// WEBPACK FOOTER //
// ./app/components/icons/CircleOChevronRight.js